module.exports = __webpack_public_path__ + "img/arrow-circle-up-p.cb7c4fd0.svg";